angular.module('ui.customer.list', ['kendo.directives', 'common.directives.inView'])
    .config(function ($stateProvider) {
        $stateProvider.state('client.customers', {
            url: '/customers',
            templateUrl: 'app/ui/customer/list/list.html',
            controller: 'CustomersController',
            controllerAs: 'CustomersController',
            data: { pageTitle: 'OrderManager: Customers' },
            resolve: {
                currentUser: function (usersRepository) {
                    return usersRepository.getCurrentUser();
                }
            },
            params: {
                filter: null
            }
        });
    })

    .controller('CustomersController', function ($window, $compile, $timeout, $rootScope, $scope, $state, $log, $q, gettext, uiLocalization, toastr, 
        appLocale, rest, authService, currentUser, serverLocalization, customersRepository, ordersRepository, templateResolver, customResourceResolver) {

// ReSharper disable once InconsistentNaming
        const CUSTOMER_ACTIVITY_PERIOD = 30; 

        $scope.user = currentUser;
        $scope.customers = null;
        $scope.customersLoadedAndSorted = false;
        $scope.permissionsGranted = false;
        $scope.topCustomerStat = { "numOrders": 0, "numOrderItems": 0, "date": "9999-12-31T23:59:59.9999999Z" };
        $scope.customersStat = { activeCustomersChange: 0 };
        $scope.limit = 30; // initial value for limit

        _.extend($scope, {
            setBusyState: setBusyState,
            customersSortByOrders: customersSortByOrders,
            customersSearch: customersSearch,
            isActiveCustomerNow: isActiveCustomerNow,
            loadMore: loadMore,
            customersLoadedAndSortedCallback: customersLoadedAndSortedCallback
        });

        initController();

        function initController() {
            setBusyState(true);

            if ($state.params.filter) {
                $scope.customerFilter = $state.params.filter.toString().trim();
            }

            initInViewLoader();

            checkCurrentUserPermissions()
                .then(function(granted) {
                    if (granted) {
                        initPageHeaderAndData()
                            .then(function() {
                                setBusyState(false);
                            });
                    } else {
                        //otherwise do nothing
                        setBusyState(false);
                    }
                })
                .catch(function(error) {
                    $log.error("Can't initialize customers list.");
                    if (error && error.message) {
                        $log.error(error.message);
                        toastr.error(uiLocalization.translate("Data request failed. Error: %s", error.message));
                    } else if (error && _.isString(error)) {
                        $log.error(error);
                        toastr.error(uiLocalization.translate("Data request failed. Error: %s", error));
                    } else if (error && error.status) {
                        toastr.error(uiLocalization.translate("Data request failed. Error %s : %s",
                            error.status,
                            error.statusText));
                    } else {
                        toastr.error(gettext("Data request failed"), gettext("Server is not responding"));
                    }
                });
        }

        function initWatchers() {

            $scope.$on(
                "$destroy",
                function () { 
                }
            );
        }

        function checkCurrentUserPermissions() {
            return $q.when($scope.user) //we have user already
                .then(function(user) {
                    //Check that current user is a centre user or a customer user who has rights to access specified customer data
                    $scope.permissionsGranted = user && !user.isCustomer();

                    if (!$scope.permissionsGranted) {
                        toastr.error('Sorry, you have no access to this data :(', 'Access denied');
                        $log.error(`User [${user.$model.name}] has no permissions to view Customer [${$scope.customerId}] data.`);
                    }

                    return $scope.permissionsGranted;
                });
        }

        /**
         * Updates busy state
         */
        function setBusyState(newBusyState) {
            $scope.isBusy = newBusyState;
        }

        function initPageHeaderAndData() {
            $scope.pageDisplayName = uiLocalization.translate('Customers Directory');

            $scope.customersStats = {};
            $scope.activeCustomersCount = 0;
            $scope.totalOrdersCount = 0;
            $scope.activeCustomersCalculated = false;

            return $q
                .all([customersRepository.getCustomers(), customersRepository.getCustomersOrdersHistoryStats()]) //get customers data and customers stats simultaneously
                .then(function(result) {
                    $scope.customers = result[0];
                    var stats = result[1];
                    
                    if ($scope.customers) {
                        $rootScope.pageTitle = uiLocalization.translate("OrderManager: Customers: %s",
                            $scope.customers ? $scope.customers.length : 0);
                    }

                    if (stats) {
                        processCustomersStats(stats);
                    }
                    $scope.activeCustomersCalculated = true;
                });
        }

        function processCustomersStats(stats) {

            var activeCustomersWeekAgo = 0;

            $scope.customers.forEach(function (c) {
                var cStat = _.find(stats, function (cs) { return cs.code === c.$model.code; });

                $scope.customersStats[c.$model.code] = cStat && cStat.stats
                    ? cStat.stats[0] : { "numOrders": 0, "numOrderItems": 0, "date": "0001-01-01T00:00:00.0000000Z" };

                if ($scope.topCustomerStat.numOrderItems <
                    $scope.customersStats[c.$model.code].numOrderItems) {
                    $scope.topCustomerStat =
                        $scope.customersStats[c.$model.code]; //remember top ordering customer
                }

                $scope.totalOrdersCount += $scope.customersStats[c.$model.code].numOrderItems;

                if (isActiveCustomerNow(c)) {
                    $scope.activeCustomersCount++;
                }
                if (isActiveCustomerWeekAgo(c)) {
                    activeCustomersWeekAgo++;
                }
            });

            $scope.customersStat.activeCustomersChange = $scope.activeCustomersCount - activeCustomersWeekAgo;
        }

        function customersLoadedAndSortedCallback () {
            $timeout(function () {
                //We can use that flag to wait till ng-repeat loads and prepares data and then reveal the content to avoid flickering
                $scope.customersLoadedAndSorted = true;
                setBusyState(false);
            }, 100);
        }

        function loadMore(isLast, isInView, inviewInfo) {
            const isInitialEvent = inviewInfo.event.type === 'initial'; 

            if ( ( (isLast && isInView) ) && $scope.limit < $scope.customers.length) {
                $scope.$applyAsync(function() {
                    $scope.limit += 50;
                });
            }
        }

        function initInViewLoader() {
            $scope.inViewLoaderOptions = {
                viewportOffset: ['1000%', 0, '1000%', 0]
            };
        }

        function customersSearch (item) {
            if (!$scope.customerFilter || !item || !item.$model)
                return true;

            const term = $scope.customerFilter.toLowerCase();

            if (item.$model.id.toString().indexOf(term) !== -1 ||
                item.$model.code.toLowerCase().indexOf(term) !== -1 ||
                item.$model.address.$model.companyName.toLowerCase().indexOf(term) !== -1) {
                return true;
            }
            return false;
        };

        function customersSortByOrders(customer) {
            var ordersCount =
                $scope.customersStats &&
                    $scope.customersStats[customer.$model.code] &&
                    $scope.customersStats[customer.$model.code].numOrderItems
                    ? $scope.customersStats[customer.$model.code].numOrderItems
                    : 0;

            return -ordersCount; //to sort by orders count and then by customer code
        }

        function isActiveCustomerNow(customer) {
            return isActiveCustomer(customer, new Date(), CUSTOMER_ACTIVITY_PERIOD);
        }

        function isActiveCustomerWeekAgo(customer) {
            var weekAgo = new Date().addDays(-7);
            return isActiveCustomer(customer, weekAgo, CUSTOMER_ACTIVITY_PERIOD);
        }

        function isActiveCustomer(customer, dateToCheckFor, daysDiff) {
            if (!customer ||
                !$scope.customersStats ||
                !$scope.customersStats[customer.$model.code] ||
                !$scope.customersStats[customer.$model.code].date)
                return false;

            return Date.diffDays(new Date($scope.customersStats[customer.$model.code].date), dateToCheckFor) < daysDiff;
        }


    })
 ;
